/**
 * Which edge of `over` a dragged row lands against. `Rules`' drop removes the
 * dragged row and re-inserts it at the target's index, so it ends up BELOW the
 * target when it came from above, and ABOVE it when it came from below.
 * `null`: nothing moves (over itself, or an id not in the list).
 */
export function dropEdge(ids: readonly string[], dragged: string, over: string): 'above' | 'below' | null {
  const from = ids.indexOf(dragged)
  const to = ids.indexOf(over)
  if (from < 0 || to < 0 || from === to) return null
  return from < to ? 'below' : 'above'
}
